import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./ThirdScreen.module.css"

const ThirdScreen = () => {
  return (
    <>
     <FAQItem 
        question="סיימתי את הקורס אבל עדיין קצת מרגישה תחושה של חוסר ביטחון מה אני אמור לעשות?"
        answer="אני כאן בשבילך גם לאחר הקורס. לכל שאלה ולהחדרת מוטיבציה. אם אני הצלחתי בתחום אין סיבה שגם את לא תצליחי !"
      />

      <FAQItem 
        question="האם צריך ניסיון קודם כדי להצטרף לקורס?"
        answer="לא אין צורך בנסיון קודם, אנחנו לומדות את כל עולם הציפורניים מאפס ."
      />
     <FAQItem 
        question="יש המון מניקורסטית בחוץ מי מבטיח שיבואו דווקא אליי?"
        answer="את צודקת בהחלט יש המון מניקוריסטיות בחוץ, והשפע מגיע לכולן ! כמו שיש המון חנויות פלאפל וחנויות פלאפונים ועדיין לכולם יש עבודה כך גם בתחום שלנו :)"
      />
                  <FAQItem 
        question="מה קורה אם אני מפספסת שיעור?"
        answer="זו לא בעיה בכלל. מתאמים לך מועד חדש שיקבע מראש ותשלימי את השיעור שהתפספס"
      />
 
      <FAQItem 
        question="איפה מתקיים הקורס"
        answer="הקורס מתקיים בסטודיו של רוחמה עמר בקרית אתא"
      />
      
            <FAQItem 
        question="למי מתאים הקורס?"
        answer="לכל אחת שמרגישה תשוקה לעולם הציפורניים ומבינה שבתחום הזה אפשר להרוויח יפה ובכך להיות אישה עצמאית שלא תלויה בבוס שינהל אותה !"
      />
      <FAQItem 
      
        question="באיזה גיל אני יכולה להתחיל ללמוד אצלך?"
        answer="מגיל 14 באישור הורים לדעתי זה גיל מושלם להתחיל ! יש משהו בגיל הזה שלא מפחדים לקחת סיכונים כי מגיעים לקורס נטו מתשוקה אמיתית לתחום וברגע שתשקיעי כבר מגילצעיר את תהיי תותחית כשתגדלי"
      />

      <FAQItem 
        question="מה ההבדל בין הקורס שלך לבין קורסים אחרים בשוק?"
        answer="ברמת העיקרון? שום דבר, כל הקולגות שלי אלופות! מה שאני מביאה לקורס שלי זה את עצמי, את מי שאני אם זה באכפתיות והסבלנות כלפי התלמידה והירידה עד לפרטים הקטנים. היחס האישי בגובה העיניים והתחושה שאתבבית ! כי כדי שהתוצאות שלך יהיו טובות את חייבת להרגיש בנוח :)"
      />
     
      <FAQItem 
        question="האם אוכל להתחיל לעבוד מיד בתום הקורס?"
        answer="הכל תלוי רק בך! זה כמו בשיעורי נהיגה.. מתי מגישים אותך לטסט? כשאת מוכנה כך גם בעולם הציפורניים, את חייבת לעשות ״שיעורים״ בדיוק כמו בנהיגה, להתאמן הרבה ואין לי ספק בכלל שתעברי טסט ראשון ;)"
      />
      <Button text="תלחצי כאן ונדבר!"/>
    </>
  )
}

export default ThirdScreen